export default {
  instoreRebatePrefix: 'Earn',
  brandedRewardName: 'MileagePlus award miles',
  rewardName: 'award miles',
  extraRewardsName: 'Extra miles',
  earnType: 'miles',
  shortProgramName: 'MileagePlus Shopping',
  instoreLabel: 'in store',
};
